<table>
	<thead>
		<tr>
			<th class="subtable icon"></th>
			<th class="subtable string sortable" (click)="toOrderBy('x=> x.lote', 'lote')">
				{{ 'global.lote' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.lote', 'lote')"></i>
                </div>
			</th>
			<th class="subtable string sortable" (click)="toOrderBy('x=> x.desFinca', 'desFinca')">
				{{ 'global.finca' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.desFinca', 'desFinca')"></i>
                </div>
			</th>
			<th class="subtable string sortable" (click)="toOrderBy('x=> x.desProvincia', 'desProvincia')">
				{{ 'global.provincia' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.desProvincia', 'desProvincia')"></i>
                </div>
			</th>
			<th class="subtable string sortable" (click)="toOrderBy('x=> x.desMunicipio', 'desMunicipio')">
				{{ 'global.municipio' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.desMunicipio', 'desMunicipio')"></i>
                </div>
			</th>
			<th class="subtable string sortable" (click)="toOrderBy('x=> x.desProductor', 'desProductor')">
				{{ 'global.productor' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.desProductor', 'desProductor')"></i>
                </div>
			</th>
			<th class="subtable number sortable" (click)="toOrderBy('x=> x.unidades', 'unidades')">
				{{ 'global.cajas' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.unidades', 'unidades')"></i>
                </div>
			</th>
			<th class="subtable date sortable" (click)="toOrderBy('x=> x.fechaConfeccion', 'fechaConfeccion')">
				{{ 'global.fecha.confeccion' | translate}}
				<div class="sortable-icons">
                    <i [ngClass]="getIcon('x=> x.fechaConfeccion', 'fechaConfeccion')"></i>
                </div>
			</th>
		</tr>
	</thead>
	<tbody *ngFor="let expedicion of expediciones; let i = index">
		<tr>
			<td class="icon"></td>
			<td class="string">{{ expedicion.lote}}</td>
			<td class="string">{{ expedicion.desFinca}}</td>
			<td class="string">{{ expedicion.desProvincia}}</td>
			<td class="string">{{ expedicion.desMunicipio}}</td>
			<td class="string">{{ expedicion.desProductor}}</td>
			<td class="number">{{ expedicion.unidades}}</td>
			<td class="date">{{ expedicion.fechaConfeccion | date: 'shortDate' : undefined : defaultLanguage }}</td>
		</tr>
	</tbody>
	<tfoot *ngIf="!expediciones || (expediciones && expediciones.length < 1)">
		<tr>
			<td colspan="8">
				{{ 'global.noContent' | translate }}
			</td>
		</tr>
	</tfoot>
</table>

<app-paginator 
    *ngIf="expediciones && expediciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
    [totalItems]="totalItems" [visiblePages]="visiblePages" 
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
</app-paginator>